(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (typeof cents !== 'number') return '';
    format = format || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      var value = (number / 100.0).toFixed(precision);
      var parts = value.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return format.replace(placeholderRegex, value);
  }

  function getCachedVariant(popup) {
    if (popup._personalizeVariant) return popup._personalizeVariant;
    var btn = popup.querySelector('[data-personalize-add-to-cart]');
    return {
      price: btn ? parseInt(btn.getAttribute('data-base-price'), 10) || 0 : 0,
      title: btn ? btn.getAttribute('data-base-summary') || '' : ''
    };
  }

  function recalcTotals(popup, variant) {
    if (variant) popup._personalizeVariant = variant;
    var v = getCachedVariant(popup);

    var addons = (window.figuroCustState && window.figuroCustState.selectedAddons) || [];
    var addonsTotal = addons.reduce(function (sum, addon) {
      return sum + (addon.price || 0);
    }, 0);
    var total = (v.price || 0) + addonsTotal;

    var moneyFormat = popup.getAttribute('data-money-format') || '${{amount}}';
    var priceEl = popup.querySelector('[data-personalize-price]');
    if (priceEl) priceEl.textContent = formatMoney(total, moneyFormat);

    var summaryEl = popup.querySelector('[data-personalize-summary]');
    if (summaryEl) {
      var parts = [v.title];
      if (!addons.length) {
        parts.push('Acrylic Base (free)');
      }
      parts = parts.concat(addons.map(function (addon) { return addon.name; }));
      summaryEl.textContent = parts.filter(Boolean).join(' · ');
    }
  }

  document.addEventListener('figuro:addons-changed', function () {
    var openPopup = document.querySelector('[data-personalize-popup]:not([hidden])');
    if (openPopup) recalcTotals(openPopup);
  });
  
  if (typeof window.VariantSelects === 'function' || typeof VariantSelects === 'function') {
    var BaseVariantSelects = typeof VariantSelects === 'function' ? VariantSelects : window.VariantSelects;

    class PersonalizeVariantSelects extends BaseVariantSelects {
      onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.updateVariantStatuses();

        var popup = this.closest('[data-personalize-popup]');
        var addToCartBtn = popup ? popup.querySelector('[data-personalize-add-to-cart]') : null;

        if (!this.currentVariant) {
          if (addToCartBtn) {
            addToCartBtn.setAttribute('aria-disabled', 'true');
            addToCartBtn.setAttribute('data-personalize-unavailable', 'true');
          }
          return;
        }

        if (addToCartBtn && addToCartBtn.hasAttribute('data-personalize-unavailable')) {
          addToCartBtn.removeAttribute('aria-disabled');
          addToCartBtn.removeAttribute('data-personalize-unavailable');
        }
        this.updateVariantInput();
        if (popup) recalcTotals(popup, this.currentVariant);
      }
    }

    if (!customElements.get('personalize-variant-selects')) {
      customElements.define('personalize-variant-selects', PersonalizeVariantSelects);
    }
  } else {
    console.error('[Personalize Popup] Could not find the theme\'s VariantSelects class to extend — is global.js loaded before this script?');
  }

  function getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }

  function relocatePopupsToBody() {
    document.querySelectorAll('[data-personalize-popup]').forEach(function (popup) {
      if (popup.parentElement !== document.body) {
        document.body.appendChild(popup);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relocatePopupsToBody);
  } else {
    relocatePopupsToBody();
  }

  function getCart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function setupStepGuide(popup) {
    if (popup.dataset.personalizeStepsReady) return;

    var steps = popup.querySelectorAll('[data-personalize-steps] .personalize-order-popup__step');
    var targets = popup.querySelectorAll('[data-personalize-step-target]');
    var scrollRoot = popup.querySelector('.personalize-order-popup__body');
    if (!steps.length || !targets.length || !scrollRoot || typeof IntersectionObserver !== 'function') return;

    popup.dataset.personalizeStepsReady = 'true';

    var stepOrder = Array.prototype.map.call(steps, function (step) {
      return step.getAttribute('data-step');
    });

    function setActiveStep(stepName) {
      var activeIndex = stepOrder.indexOf(stepName);
      if (activeIndex === -1) return;
      Array.prototype.forEach.call(steps, function (step, index) {
        step.classList.toggle('is-active', index === activeIndex);
        step.classList.toggle('is-complete', index < activeIndex);
      });
    }

    var currentRatios = {};
    Array.prototype.forEach.call(targets, function (target) {
      currentRatios[target.getAttribute('data-personalize-step-target')] = 0;
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var key = entry.target.getAttribute('data-personalize-step-target');
          currentRatios[key] = entry.isIntersecting ? entry.intersectionRatio : 0;
        });

        var bestKey = stepOrder[0];
        stepOrder.forEach(function (key) {
          if (currentRatios[key] >= 0.4) {
            bestKey = key;
          }
        });
        setActiveStep(bestKey);
      },
      { root: scrollRoot, threshold: [0, 0.15, 0.3, 0.45, 0.6, 0.75, 0.9, 1] }
    );

    Array.prototype.forEach.call(targets, function (target) {
      observer.observe(target);
    });

    var SCROLL_EDGE_PX = 4;
    scrollRoot.addEventListener(
      'scroll',
      function () {
        if (scrollRoot.scrollTop <= SCROLL_EDGE_PX) {
          setActiveStep(stepOrder[0]);
        } else if (scrollRoot.scrollTop + scrollRoot.clientHeight >= scrollRoot.scrollHeight - SCROLL_EDGE_PX) {
          setActiveStep(stepOrder[stepOrder.length - 1]);
        }
      },
      { passive: true }
    );
  }

  function openPopup(popup) {
    popup.hidden = false;
    document.body.style.paddingRight = getScrollbarWidth() + 'px';
    document.body.classList.add('overflow-hidden');
    setupStepGuide(popup);
    recalcTotals(popup);
    var closeBtn = popup.querySelector('[data-personalize-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closePopup(popup) {
    popup.hidden = true;
    var anyOtherOpen = Array.prototype.some.call(
      document.querySelectorAll('[data-personalize-popup]'),
      function (p) { return p !== popup && !p.hidden; }
    );
    if (!anyOtherOpen) {
      document.body.classList.remove('overflow-hidden');
      document.body.style.paddingRight = '';
    }
  }

  function showError(popup, message) {
    var errorEl = popup.querySelector('[data-personalize-error]');
    if (!errorEl) return;
    if (!message) {
      errorEl.hidden = true;
      errorEl.textContent = '';
      return;
    }
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  function setLoading(popup, isLoading) {
    var btn = popup.querySelector('[data-personalize-add-to-cart]');
    var spinner = popup.querySelector('[data-personalize-spinner]');
    if (!btn) return;
    if (isLoading) {
      btn.setAttribute('aria-disabled', 'true');
      if (spinner) spinner.hidden = false;
    } else {
      btn.removeAttribute('aria-disabled');
      if (spinner) spinner.hidden = true;
    }
  }

  function getSelectedVariantId(popup) {
    var formId = popup.getAttribute('data-product-form-id');
    if (!formId) return null;
    var form = document.getElementById(formId);
    if (!form) return null;
    var input = form.querySelector('input[name="id"]');
    return input ? input.value : null;
  }

  function getLineItemProperties(popup) {
    var properties = {};
    popup.querySelectorAll('[data-figuro-input]').forEach(function (input) {
      var match = input.name && input.name.match(/^properties\[(.+)\]$/);
      if (match && input.value) {
        properties[match[1]] = input.value;
      }
    });
    return properties;
  }

  function getAddonCartItems(quantity) {
    var state = window.figuroCustState;
    var selectedAddons = (state && state.selectedAddons) || [];

    return selectedAddons.map(function (addon) {
      var properties = {};
      var engraving = state.engravings && state.engravings[addon.addonId];
      if (engraving) {
        properties['Engraving Text'] = engraving;
      }
      return {
        id: addon.variantId,
        quantity: quantity,
        properties: properties
      };
    });
  }

  function addToCart(popup) {
    if (popup.querySelector('[data-personalize-add-to-cart]').getAttribute('aria-disabled') === 'true') {
      return;
    }

    showError(popup, '');

    var variantId = getSelectedVariantId(popup);
    if (!variantId) {
      showError(popup, 'Please select an option before adding to cart.');
      return;
    }

    var properties = getLineItemProperties(popup);
    if (!properties['Image URL 1'] && !properties['AI Processed Image']) {
      showError(popup, 'Please upload a photo and generate a preview before adding to cart.');
      return;
    }

    var addonItems = getAddonCartItems(1);
    var addonNames = ((window.figuroCustState && window.figuroCustState.selectedAddons) || [])
      .map(function (addon) {
        return addon.name;
      });
    if (addonNames.length) {
      properties['_addon'] = addonNames.join(', ');
    }

    setLoading(popup, true);

    var cart = getCart();
    var items = [
      {
        id: variantId,
        quantity: 1,
        properties: properties
      }
    ].concat(addonItems);

    var payload = { items: items };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
      payload.sections_url = window.location.pathname;
    }

    var cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

    fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.text().then(function (text) {
          var data;
          try {
            data = JSON.parse(text);
          } catch (parseError) {
            console.error('[Personalize Popup] Non-JSON response from', cartAddUrl, '- status:', response.status, '- body:', text.slice(0, 500));
            throw new Error('The store returned an unexpected response (status ' + response.status + ').');
          }
          if (!response.ok && !data.status) {
            data.status = response.status;
          }
          return data;
        });
      })
      .then(function (data) {
        if (data.status) {
          console.error('[Personalize Popup] Cart add API error:', data);
          showError(popup, data.description || data.message || 'Could not add this item to your cart.');
          setLoading(popup, false);
          return;
        }

        closePopup(popup);
        setLoading(popup, false);

        if (cart && typeof cart.renderContents === 'function') {
          console.log(
            '[Personalize Popup] cart/add.js response — sections returned:',
            data.sections ? Object.keys(data.sections) : '(no "sections" key in response)'
          );
          try {
            cart.renderContents(data);
          } catch (renderError) {
            console.error('[Personalize Popup] cart.renderContents() threw:', renderError);
          }
        } else if (window.routes && window.routes.cart_url) {
          window.location = window.routes.cart_url;
        }
      })
      .catch(function (error) {
        console.error('[Personalize Popup] Add to cart failed:', error);
        showError(popup, error && error.message ? error.message : 'Something went wrong. Please try again.');
        setLoading(popup, false);
      });
  }

  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-personalize-open]');
    if (openTrigger) {
      var popupId = openTrigger.getAttribute('aria-controls');
      var popup = popupId ? document.getElementById(popupId) : null;
      if (popup) openPopup(popup);
      return;
    }

    var closeTrigger = event.target.closest('[data-personalize-close]');
    if (closeTrigger) {
      var popupToClose = closeTrigger.closest('[data-personalize-popup]');
      if (popupToClose) closePopup(popupToClose);
      return;
    }

    var addToCartTrigger = event.target.closest('[data-personalize-add-to-cart]');
    if (addToCartTrigger) {
      var popupForCart = addToCartTrigger.closest('[data-personalize-popup]');
      if (popupForCart) addToCart(popupForCart);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-personalize-popup]').forEach(function (popup) {
      if (!popup.hidden) closePopup(popup);
    });
  });
})();
